import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import avatar from "../../../images/no-image.png";
//Global State using JOTAI
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";
import MainAdminComponent from "./MainAdminComponent";

const Topbar = ({ user, toggleMenu, onLogout, isMenuOpen }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  let navigate = useNavigate();
  const [userStatus, setUserStatus] = useAtom(gbState);
  const [userData, setData] = useState(null);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  const handleLogout = () => {
    localStorage.removeItem("token");
    sessionStorage.removeItem("user-details");
    setUserStatus({ ...userStatus, user: null });
    navigate("/login", { replace: true });
  };
  useEffect(() => {
    let userToken = localStorage.getItem("token");
    let urlLink = "";
    if (userStatus?.user?.role === "CHURCH_ADMIN") {
      urlLink = `${process.env.REACT_APP_API_URL}/user/${userStatus?.user?._id}`;
    } else {
      if (userStatus?.user?._id)
        urlLink = `${process.env.REACT_APP_API_URL}/family/primaryMember/${userStatus?.user?._id}`;
    }
    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(config)
      .then(function (response) {
        if (userStatus?.user?.role === "CHURCH_ADMIN") {
          const oldData = response?.data?.users;
          setData(oldData);
        } else {
          const oldData = response?.data?.families;
          setData(oldData[0]);
        }
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  }, []);
  localStorage.setItem("user_image", userData?.image);
  // console.log(userStatus?.user?.role);
  return (
    <header
      className={`flex items-center justify-between p-4  shadow-md transition-all duration-300 ${
        isMenuOpen ? "md:ml-34" : "ml-16 md:ml-0"
      }`}
      style={{ backgroundColor: "#87ceeb" }}
    >
      <div className="flex items-center">
        <button
          onClick={toggleMenu}
          className="text-gray-500 hover:text-gray-700 focus:outline-none"
          aria-label="Toggle menu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
        <h1 className="ml-4 text-xl font-semibold">
          {userStatus?.user?.church_name}
        </h1>
      </div>

      <div className="flex items-center">
        <div className="relative">
          <button
            onClick={toggleDropdown}
            // onMouseEnter={() => setDropdownOpen(true)}
            className="flex items-center focus:outline-none"
          >
            {userData?.image && (
              <img
                crossOrigin="anonymous"
                src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/${
                  userStatus?.user?.user_role === "CHURCH_ADMIN"
                    ? "employee"
                    : "family"
                }/${userData?.image}`}
                style={{ height: "50px", width: "50px" }}
                className="rounded-full w-[60px] p-0 mr-1"
              />
            )}
            {!userData?.image && (
              <img
                src={avatar}
                className="rounded-full w-[40px] p-1 mr-1"
                style={{ height: "50px", width: "70px" }}
              />
            )}
            <span className="block text-left truncate w-27">
              {userStatus?.user?.name}
              <span className="block text-xs font-light text-left text-black">
                {userStatus?.user?.user_type}
              </span>
              <span className="block font-light text-left text-black text-[10px]">
                {userStatus?.user?.current_financial_year}
              </span>
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
          {dropdownOpen && (
            <div
              className="absolute right-0 z-10 w-48 py-1 mt-2 bg-white rounded-md shadow-lg"
              // onMouseEnter={() => setDropdownOpen(true)}
              onMouseLeave={() => setDropdownOpen(false)}
            >
              {userStatus?.user?.role === "FULL_ACCESS" && (
                <>
                  <MainAdminComponent />
                  <hr />
                </>
              )}
              <a
                onClick={() => navigate("/updateProfile")}
                className="block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100"
              >
                My Profile
              </a>
              {userStatus?.user?.role === "CHURCH_ADMIN" && (
                <a
                  onClick={() =>
                    navigate("/church/profile", { state: userStatus?.user })
                  }
                  className="block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100"
                >
                  Church Profile
                </a>
              )}
              {userStatus?.user?.role === "CHURCH_ADMIN" && (
                <a
                  onClick={() => navigate("/closure/history")}
                  className="block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100"
                >
                  Closure History
                </a>
              )}
              <a
                onClick={() => navigate("/updatePassword")}
                className="block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100"
              >
                Change Password
              </a>
              <hr />
              <a
                onClick={handleLogout}
                className="block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100"
              >
                Logout
              </a>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Topbar;
